// @ts-nocheck
import { FETCH_CURRENT_USER_FULFILLED, FETCH_CURRENT_USER_REJECTED, SET_AUTHENTICATED, SET_AUTHENTICATING } from './authActionTypes';

const initialState = {
  authenticated: false,
  authenticating: false,
  currentUser: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_CURRENT_USER_FULFILLED:
      return {
        ...state,
        authenticated: true,
        currentUser: action.payload,
      };
    case FETCH_CURRENT_USER_REJECTED:
      return {
        ...state,
        authenticated: false,
        currentUser: null,
      };
    case SET_AUTHENTICATED:
      return {
        ...state,
        authenticated: action.payload,
      };
    case SET_AUTHENTICATING:
      return {
        ...state,
        authenticating: action.payload,
      };
    default:
      return state;
  }
}
